import React, { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

const UserCard = ({ user }) => (
  <div className="bg-white rounded-lg w-full overflow-y-auto shadow-md p-3 flex items-center space-x-3 mb-2 hover:shadow-lg transition-shadow duration-200">
    <div className="flex-shrink-0">
      <div className="w-10 h-10 rounded-full bg-gray-200 overflow-hidden flex items-center justify-center">
        <img
          src={user.profile || "/api/placeholder/40/40"}
          alt={user.name}
          className="w-full h-full object-cover"
          onError={(e) => (e.target.src = "/api/placeholder/40/40")}
        />
      </div>
    </div>
    <div className="flex-1 min-w-0">
      <p className="text-sm font-medium text-gray-900 truncate">{user.name}</p>
      <p className="text-xs text-gray-500">ชั้น: {user.layer}</p>
    </div>
  </div>
);

const UserNode = ({ user, expandedUsers, toggleExpand }) => {
    const isExpanded = !!expandedUsers[user.uid];
    return (
      <div className="flex flex-col">
        <div className="flex items-center">
          <div className="flex-1">
            <UserCard user={user} />
          </div>
          {user.children.length > 0 && (
            <button onClick={() => toggleExpand(user.uid)} className="ml-2">
              {isExpanded ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
            </button>
          )}
        </div>
        <div
          style={{
            opacity: isExpanded ? 1 : 0,
            maxHeight: isExpanded ? "1000px" : "0",
            overflow: "hidden",
            transition: "opacity 0.3s ease-in-out, max-height 0.3s ease-in-out",
          }}
          className="pl-6 border-l-2 border-gray-300 ml-5 mt-1"
        >
          {user.children.map((child) => (
            <UserNode
              key={child.uid}
              user={child}
              expandedUsers={expandedUsers}
              toggleExpand={toggleExpand}
            />
          ))}
        </div>
      </div>
    );
  };
export default function OrgChartWithAPI({ apiData, loading = false, error = null, onRefresh  , setOrgChartData}) {
  const [data, setData] = useState([]);
  const [expandedUsers, setExpandedUsers] = useState({});
  console.log("Api data" , apiData)
  React.useEffect(() => {
    if (apiData) {
      const processedData = processApiData(apiData);
      setData(processedData);
    }
  }, [apiData]);

  const processApiData = (rawData) => {
    const layerGroups = {};
    rawData.forEach((item) => {
      const layer = item.layer;
      if (!layerGroups[layer]) layerGroups[layer] = [];
      layerGroups[layer].push(item);
    });

    const layer1Users = {};
    if (layerGroups[1]) {
      layerGroups[1].forEach((item) => {
        if (!layer1Users[item.inviter_uid]) {
          layer1Users[item.inviter_uid] = {
            name: item.inviter_uname,
            uid: item.inviter_uid,
            age: item.inviter_age,
            profile: item.inviter_profile_image,
            layer: item.layer, // Add layer property
            children: [],
          };
        }
      });
    }

    if (layerGroups[2]) {
      layerGroups[2].forEach((item) => {
        const parentUid = item.inviter_uid;
        if (layer1Users[parentUid]) {
          const childUser = {
            name: item.invitee_uname,
            uid: item.invitee_uid,
            age: item.invitee_age,
            profile: item.invitee_profile_image,
            layer: item.layer, // Add layer property
            children: [],
          };
          if (!layer1Users[parentUid].children.find((c) => c.uid === childUser.uid)) {
            layer1Users[parentUid].children.push(childUser);
          }
        }
      });
    }

    if (layerGroups[3]) {
      layerGroups[3].forEach((item) => {
        const parentUid = item.inviter_uid;
        Object.values(layer1Users).forEach((layer1User) => {
          const layer2Parent = layer1User.children.find((child) => child.uid === parentUid);
          if (layer2Parent) {
            const childUser = {
              name: item.invitee_uname,
              uid: item.invitee_uid,
              age: item.invitee_age,
              profile: item.invitee_profile_image,
              layer: item.layer, // Add layer property
              children: [],
            };
            if (!layer2Parent.children.find((c) => c.uid === childUser.uid)) {
              layer2Parent.children.push(childUser);
            }
          }
        });
      });
    }

    return Object.values(layer1Users);
  };

  const toggleExpand = (uid) => {
    setExpandedUsers((prev) => ({
      ...prev,
      [uid]: !prev[uid],
    }));
  };

  if (loading) {
    return (
      <div className="p-4 max-w-full flex justify-center items-center h-64">
        <div className="text-center">
          <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-blue-500 border-r-transparent"></div>
          <p className="mt-2 text-gray-600">กำลังโหลดข้อมูล...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="p-4 max-w-full">
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative" role="alert">
          <strong className="font-bold">เกิดข้อผิดพลาด!</strong>
          <span className="block sm:inline"> ไม่สามารถโหลดข้อมูลได้: {error}</span>
          {onRefresh && (
            <button
              className="mt-2 bg-red-500 hover:bg-red-700 text-white font-bold py-1 px-4 rounded"
              onClick={onRefresh}
            >
              ลองใหม่
            </button>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white w-full h-full overflow-y-auto  absolute bottom-0 z-[90] left-1/2 transform -translate-x-1/2">
      <div className="bg-gray-100 p-4 mb-6 rounded-lg">
      {apiData.length > 0 && <h2 className="text-xl font-bold text-center mb-2">
  ไอดี อสังหาฯ: {apiData[0]?.asset_id}
</h2>}

        <div className="w-full h-full flex justify-center items-center gap-x-2.5 ">
        {onRefresh && (
          <div className="flex justify-center mt-3">
            <button
              className="bg-blue-500 hover:bg-blue-700 rounded-full text-white font-bold py-2 px-4 "
              onClick={onRefresh}
            >
              รีเฟรชข้อมูล
            </button>
          </div>
        )}
        <div className="flex justify-center mt-3">
            <button
              className="bg-red-500 text-white font-bold py-2 px-4 rounded-full"
              onClick={()=>setOrgChartData(null)}
            >
              ปิดหน้าต่าง
            </button>
          </div>
          </div>
      </div>
      <div className="p-4">
        {data.length > 0 ? (
          data.map((user) => (
            <UserNode
              key={user.uid}
              user={user}
              expandedUsers={expandedUsers}
              toggleExpand={toggleExpand}
            />
          ))
        ) : (
          <div className="text-center p-4 bg-yellow-100 rounded-lg">
            <p>ไม่พบข้อมูล</p>
          </div>
        )}
      </div>
    </div>
  );
}